import { ContentBlocks } from "src/ui/ContentBlocks";
import { SeoHead } from "src/ui/SeoHead";

export default function HomePage({ prefix, title, canonical, data }) {
  return (
    <>
      <SeoHead title={title} canonical={canonical} />
      <ContentBlocks data={data} prefix={prefix} />
    </>
  );
}

export async function getStaticProps() {
  return {
    props: {
      prefix: "sustainability-evertreen-partnership",
      title: "Sustainability Evertreen Partnership",
      canonical: "/candidates/sustainability-evertreen-partnership/",
      data: [
        {
          component: "Hero",
          props: {
            image: "/assets/contractor_hero.webp",
            title: "Sustainability Evertreen Partnership",
          },
        },
        {
          component: "ContentSideImage_001",
          props: {
            className: "pb-5 pb-lg-6 pt-5 pt-lg-6",
            reverse: true,
            tagline: "Advice for Contractors",
            title:
              "The life science industry is constantly evolving, so advice for contractors is always necessary.",
            description:
              "<p>Contract workers play an essential role within STEM businesses of all sizes. Here at HRS, we work with some of the UK’s top scientific employers and offer a wide range of temporary contract worker roles alongside information for contractors.</p><p>HRS is one of the most professional and reliable recruitment companies for contract workers in science – not only can we provide you with a rewarding position, but we also supply you with insightful contractor information to ease you into your new role.</p><p>Get in touch today to find out more about how we provide help and advice for contractors. Alternatively, use the buttons below to learn more about the contractor information we have available.</p>",
            bg: true,
          },
        },
        {
          component: "ContentSideImage_001",
          props: {
            className: "pb-5 pb-lg-6 pt-5 pt-lg-6 bg-light mb-6",
            tagline: "Advice for Contractors",
            title:
              "The life science industry is constantly evolving, so advice for contractors is always necessary.",
            description:
              "<p>Contract workers play an essential role within STEM businesses of all sizes. Here at HRS, we work with some of the UK’s top scientific employers and offer a wide range of temporary contract worker roles alongside information for contractors.</p><p>HRS is one of the most professional and reliable recruitment companies for contract workers in science – not only can we provide you with a rewarding position, but we also supply you with insightful contractor information to ease you into your new role.</p><p>Get in touch today to find out more about how we provide help and advice for contractors. Alternatively, use the buttons below to learn more about the contractor information we have available.</p>",
            bg: true,
          },
        },
        {
          component: "Embedded",
          props: {
            className: "pb-5 pb-lg-6",
            tagline: "Advice for Contractors",
            title:
              "The life science industry is constantly evolving, so advice for contractors is always necessary.",
            description:
              "<p>Contract workers play an essential role within STEM businesses of all sizes. Here at HRS, we work with some of the UK’s top scientific employers and offer a wide range of temporary contract worker roles alongside information for contractors.</p><p>HRS is one of the most professional and reliable recruitment companies for contract workers in science – not only can we provide you with a rewarding position, but we also supply you with insightful contractor information to ease you into your new role.</p><p>Get in touch today to find out more about how we provide help and advice for contractors. Alternatively, use the buttons below to learn more about the contractor information we have available.</p>",
            bg: true,
          },
        },
      ],
    },
  };
}
